import { useEffect, useState } from 'react';
import { Country } from '../types/Country';
import { fetchCountriesService } from '../services/countryService';

export const useCountries = () => {
  const [data, setData] = useState<Country[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCountries = async () => {
    setLoading(true);
    setError(null);
    try {
      const countries = await fetchCountriesService();
      setData(countries);
    } catch (err: any) {
      setError(err.message || 'Failed to fetch countries.');
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, fetchCountries };
};
